export const TOOLTIP_PROPS = {
    maxSize: {
        x: "25%", y: "-75%",
        width: "140px",
        after: {
            x: "-350%", y: "-170%",
            angle: "135deg"
        }
    },
    minSize: {
        x: "-75%",
        y: "-180%",
        width: "130px",
        after: {
            x: "170%", y: "-15%",
            angle: "45deg"
        }
    }
};
